import dayjs, { Dayjs } from 'dayjs';
import advanced from 'dayjs/plugin/advancedFormat';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(advanced);
dayjs.extend(LocalizedFormat);

/**
 * Formats a timestamp (sec) or date string
 * @param date Timestamp in sec or Date string
 */
export const formatDate = (
  date?: string | number | Date | Dayjs,
  format?: string,
  useOnlyUTC = false
): string => {
  if (!date) return '';

  let dateObj = typeof date === 'number' ? dayjs.unix(date) : dayjs(date);
  if (isNaN(dateObj.toDate().getTime())) return '';
  // adding this check to ignore DB default date (0001-01-01T00:00:00Z)
  if (dateObj.year() < 1900) return '';

  if (useOnlyUTC) dateObj = dateObj.utc();

  return dateObj.format(format);
};

export const addDays = (date: Date, days: number): Date => {
  return dayjs(date).add(days, 'day').toDate();
};

export const getDaysDifference = (
  date1: string | number | Date,
  date2: string | number | Date
): number => {
  const dateObj1 = typeof date1 === 'number' ? dayjs.unix(date1) : dayjs(date1);
  const dateObj2 = typeof date2 === 'number' ? dayjs.unix(date2) : dayjs(date2);

  if (isNaN(dateObj1.toDate().getTime()) || isNaN(dateObj2.toDate().getTime())) return 0;

  return dateObj1.diff(dateObj2, 'day');
};
